import { render, staticRenderFns } from "./activeCode.vue?vue&type=template&id=29824478&"
import script from "./activeCode.vue?vue&type=script&lang=js&"
export * from "./activeCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports